import React from "react";
import { FileTextIcon } from "assets";
import { UTILITY_BILL_PAGE as ROUTE_UTILITY_BILL_PAGE } from "./route-consts";

export const UTILITY_BILLS_PAGE = {
  ABSOLUTE_PATH: "/documents/summary",
  PATH: "summary/*",
  TITLE: "Document summary",
  ICON: <FileTextIcon />,
};

export const UTILITY_BILL_PAGE = ROUTE_UTILITY_BILL_PAGE;

export const UTILITY_BILLS_TABLE = {
  COLUMN_TO_SORT_COLUMN_MAP: {
    amount: "COST",
    co2Emission: "EMISSIONS",
    endDate: "END_DATE",
    startDate: "START_DATE",
    measuredValue: "USAGE",
  },
  INITIAL_SORTING_STATE: [{ id: "startDate", desc: true }],
  ROWS_PER_PAGE_OPTIONS: [100, 200, 500, 1000]
};
